import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i8.1
import React from 'react';
import IconWrap from '../IconWrap';
const Unwatch = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M15.589 15.343l-1.499-1.838a2.813 2.813 0 0 0 .685-1.835 2.796 2.796 0 0 0-2.812-2.813c-.502 0-.962.139-1.366.361L9.302 7.63a6.304 6.304 0 0 1 2.627-.572c3.9 0 6.14 3.496 6.803 4.716-.415.771-1.454 2.44-3.143 3.569m-3.66 1.143c-3.897 0-6.137-3.492-6.802-4.714.422-.774 1.475-2.455 3.178-3.585L9.743 9.95a2.799 2.799 0 0 0-.593 1.719 2.803 2.803 0 0 0 4.051 2.525l1.39 1.706a6.323 6.323 0 0 1-2.662.585m8.819-4.299l.18-.415-.18-.415c-.112-.26-2.823-6.335-8.82-6.335a8.291 8.291 0 0 0-3.947.987l-1.79-2.197-.873.71 1.7 2.085c-2.594 1.82-3.833 4.577-3.908 4.75l-.181.415.181.415c.113.259 2.823 6.335 8.819 6.335 1.541 0 2.86-.405 3.98-1.005l1.648 2.022.872-.71-1.56-1.913c2.574-1.82 3.805-4.556 3.879-4.729"
    }))));
Unwatch.displayName = 'Unwatch';
export default Unwatch;
